import React from "react";

/**
 * Muestra un mensaje de error de validación debajo de un campo.
 * Uso: <FieldError error={this.state.formErrors.campo} />
 */
const FieldError = ({ error }) => {
  if (!error) return null;
  return (
    <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "2px" }}>
      {error}
    </span>
  );
};

export default FieldError;
